import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useContext, useEffect } from 'react';
import { SebastianStatus } from '~/constants/common/SebastianStatus';
import SebastianContext from '~/context/common/SebastianContext';
import {
  CHAT_UI_MODULE,
  selectIsMfeReady,
  useMfeLoadStore
} from '~/state/common/MfeLoadState';

// The name the ChatUI MFE reports in mfer.events payloads — no typed constant exists in eventNames.
const CHAT_UI_EVENT = 'header-chat-ui';
const selectIsChatUiReady = selectIsMfeReady(CHAT_UI_MODULE);

export default function useSebastianLoaded() {
  const { setSebastianStatus } = useContext(SebastianContext);
  const isChatUiReady = useMfeLoadStore(selectIsChatUiReady);

  // MfeEventsListener records CHAT_UI_READY with withHistory: true, so this is already
  // correct on mount even if the event fired during a previous VDP mount.
  useEffect(() => {
    if (isChatUiReady) setSebastianStatus(SebastianStatus.Ready);
  }, [isChatUiReady, setSebastianStatus]);

  useCoreEvents(eventNames.mfer.events, event => {
    if (event.name === CHAT_UI_EVENT && event.error) {
      setSebastianStatus(SebastianStatus.Error);
    }
  });
}
